const selectors = {
  relatedSection: '[data-related-section]',
  aos: '[data-aos]',
  tabBtn: '[data-tab-button]',
  tabContent: '[data-tab-content]',
  tabLinkRecent: '.tab-link__recent',
};

const classes = {
  current: 'current',
  aosAnimate: 'aos-animate',
  aosNoTransition: 'aos-no-transition',
  focused: 'is-focused',
};

const attributes = {
  dataTab: 'data-tab',
};

if (!customElements.get('tabs-component')) {
  customElements.define(
    'tabs-component',
    class GlobalTabs extends HTMLElement {
      constructor() {
        super();

        this.a11y = window.theme.a11y;
      }

      connectedCallback() {
        const tabsNavList = this.querySelectorAll(selectors.tabBtn);

        this.addEventListener('theme:tab:check', () => this.checkRecentTab());
        this.addEventListener('theme:tab:hide', () => this.hideRelatedTab());

        tabsNavList?.forEach((element) => {
          const tabId = element.getAttribute('aria-controls');
          const tab = this.querySelector(`#${tabId}`);

          element.addEventListener('click', () => {
            this.tabChange(element, tab);
          });

          element.addEventListener('keyup', (event) => {
            if ((event.code === 'Space' || event.code === 'Enter') && document.body.classList.contains(classes.focused)) {
              this.tabChange(element, tab);
            }
          });
        });
      }

      tabChange(element, tab) {
        if (element.getAttribute('aria-selected') === 'true') {
          return;
        }

        const targetTabValue = element.getAttribute('aria-controls');
        const currentTabs = Array.from(this.querySelectorAll(`${selectors.tabBtn}[aria-selected="true"]`));
        const currentTabContent = this.querySelector(`${selectors.tabContent}[aria-hidden="false"]`);

        currentTabs?.forEach((tabEl) => tabEl.setAttribute('aria-selected', 'false'));
        currentTabContent?.setAttribute('aria-hidden', 'true');

        const allTabBtns = Array.from(this.querySelectorAll(`[aria-controls="${targetTabValue}"]`));

        allTabBtns.forEach((tabBtnItem) => tabBtnItem.setAttribute('aria-selected', 'true'));
        tab.setAttribute('aria-hidden', 'false');

        this.a11y.removeTrapFocus();

        this.dispatchEvent(new CustomEvent('theme:tab:change', {bubbles: true}));

        element.dispatchEvent(
          new CustomEvent('theme:form:sticky', {
            bubbles: true,
            detail: {
              element: 'tab',
            },
          })
        );

        this.animateItems(tab);

        this.scrollIntoViewIfAboveViewport();
      }

      scrollIntoViewIfAboveViewport(offset = 0) {
        const top = this.getBoundingClientRect().top;

        if (top < 0) {
          const scrollTo = this.offsetTop - offset;
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        }
      }

      animateItems(tab, animated = true) {
        const animatedItems = tab.querySelectorAll(selectors.aos);

        if (animatedItems.length) {
          animatedItems.forEach((animatedItem) => {
            animatedItem.classList.remove(classes.aosAnimate);

            if (animated) {
              animatedItem.classList.add(classes.aosNoTransition);

              requestAnimationFrame(() => {
                animatedItem.classList.remove(classes.aosNoTransition);
                animatedItem.classList.add(classes.aosAnimate);
              });
            }
          });
        }
      }

      checkRecentTab() {
        const tabLink = this.querySelector(selectors.tabLinkRecent);

        if (tabLink) {
          tabLink.setAttribute('aria-selected', 'true');
          const tabLinkId = tabLink.getAttribute('aria-controls');
          const tabContent = this.querySelector(`#${tabLinkId}`);

          if (tabContent) {
            tabContent.setAttribute('aria-hidden', 'false');

            this.animateItems(tabContent, false);
          }
        }
      }

      hideRelatedTab() {
        const relatedSection = this.querySelector(selectors.relatedSection);
        if (!relatedSection) {
          return;
        }

        const parentTabContent = relatedSection.closest(`${selectors.tabContent}[aria-hidden="false"]`);
        if (!parentTabContent) {
          return;
        }
        const parentTabContentId = parentTabContent.getAttribute('id');
        const tabsNavList = this.querySelectorAll(selectors.tabBtn);

        if (tabsNavList.length > parentTabContentId) {
          const nextTabsNavLink = tabsNavList[parentTabContentId].nextSibling;

          if (nextTabsNavLink) {
            nextTabsNavLink.dispatchEvent(new Event('click'));
          }
        }
      }
    }
  );
}
